import { Observable } from "rxjs";
import * as http from "../../../services/http.service";
import { SearchResults } from "../../../types/search/search-results.interface";
import { ProductSubcategory } from "../types/product-subcategory.interface";

export function searchProductSubcategories(
  searchText: string
): Observable<SearchResults<ProductSubcategory>> {
  return http.get(`/search/products-subcategories/?q=${searchText}`);
}
